export default __webpack_public_path__ + "static/api-512d36c09662682717108a38bbb5c57d.gif";